import BaseStimulusModelController from "../../../BaseStimulusModelController";
import { HintPopupStimulusModel } from "../../../../scripts/_generated/HintPopupStimulusModel";
import { createPopper, Instance } from '@popperjs/core';
import './HintPopup.scss';

export default class HintPopupController extends BaseStimulusModelController<HintPopupStimulusModel> { // popper code taken from https://codepen.io/Buthrakaur/pen/RwJBBmJ and modified
    static targets = [
        "popperPopup",
        "popperArrow",
        "popupContent"
    ];

    readonly popperPopupTarget!: HTMLElement;
    readonly popperArrowTarget!: HTMLElement;
    readonly popupContentTarget!: HTMLElement;

    popperInstance: Instance | undefined;

    connect() {
    }
   
    createPopperInstance(reference: Element) {
        this.popperInstance = createPopper(reference, this.popperPopupTarget, {
            placement: "auto", //preferred placement of popper
            modifiers: [
                {
                    name: "offset", //offsets popper from the reference/button
                    options: {
                        offset: [0, 8]
                    }
                },
                {
                    name: "flip", //flips popper with allowed placements
                    options: {
                        allowedAutoPlacements: ["right", "left", "top", "bottom"],
                        rootBoundary: "viewport"
                    }
                }
            ]
        });
    }

    destroyPopperInstance() {
        if (this.popperInstance) {
            this.popperInstance.destroy();
            this.popperInstance = undefined;
        }
    }

    createAndShowPopper(reference: Element, popupHtmlContent: string) {
        if (this.popperInstance) {
            this.hideAndDestroyPopper();
        }

        this.popupContentTarget.innerHTML = popupHtmlContent;
        this.popperPopupTarget.setAttribute("show-popper", "");
        this.popperArrowTarget.setAttribute("data-popper-arrow", "");
        this.createPopperInstance(reference);
    }

    hideAndDestroyPopper() {
        this.popperPopupTarget.removeAttribute("show-popper");
        this.popperArrowTarget.removeAttribute("data-popper-arrow");
        this.destroyPopperInstance();
    }

    closePopup(e: Event) {
        e.preventDefault();
        e.stopImmediatePropagation();
        this.hideAndDestroyPopper();
    }
}

